
import SignInFlow from "./registration/cal-sign-in-flow.vue";
import SignUpFlow from "./registration/cal-sign-up-flow.vue";

export default {
  name: "cal-user-addresses",
  components: {
    SignInFlow,
    SignUpFlow,
  },
  data() {
    return {
      showSignInFlow: false,
      showSignUpFlow: false,
      addresses: [],
      loading: false,
      //TODO: extract into component
      isDragging: false,
      toggleSelected: false,
      startX: 0,
      currentX: 0,
    };
  },
  computed: {
    hasAddresses() {
      this.addresses = this.$store.state.account.addresses;
      return this.addresses.length > 0;
    },
  },
  props: {
    showRegistrationOptions: false,
  },
  methods: {
    toggleAddress(index) {
      this.toggleSelected = !this.toggleSelected;
      const selectedIndex = this.addresses.findIndex((a) => a.selected);

      if (selectedIndex != index && this.addresses[selectedIndex]) {
        this.addresses[selectedIndex].selected = false;
      }
      this.addresses[index].selected = true;

      this.$emit("userAddressSelected", this.addresses[index]);
    },
    async getAddresses() {
      this.loading = true;
      await this.$store.dispatch("account/AUTHENTICATE_USER");
      await this.$store.dispatch("account/ADDRESSES");
      this.loading = false;
    },
    handleWheel(event) {
      event.preventDefault();
      const scrollable = this.$el.querySelector(".scrollbar");
      scrollable.scrollTo({
        left: scrollable.scrollLeft + event.deltaY,
        behavior: "smooth",
      });
    },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX || event.touches[0].clientX;
      event.preventDefault();
    },
    drag(event) {
      if (this.isDragging) {
        const currentX = event.clientX || event.touches[0].clientX;
        const delta = currentX - this.startX;
        this.$el.querySelector(".scrollbar").scrollLeft -= delta;
        this.startX = currentX;
      }
    },
    endDrag() {
      this.isDragging = false;
    },
  },
};
